import React from 'react'
import ReactDatePicker from 'react-datepicker'
import { createPortal } from 'react-dom'
import TextInput from '../TextInput'

const toDate = (value) => {
  if (!value || value instanceof Date) {
    return value
  }

  return new Date(value)
}

const DatePicker = ({ value, placeholder, onChange, styleProps, customInput, ...props }) => {
  const selectedDate = toDate(value)

  return (
    <ReactDatePicker
      autoComplete="off"
      todayButton="Today"
      peekNextMonth
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      selected={selectedDate}
      placeholderText={placeholder}
      customInput={customInput || <TextInput {...props} />}
      onChange={onChange}
      {...props}
      popperContainer={({ children }) => createPortal(children, document.body)}
      popperModifiers={{
        preventOverflow: {
          enabled: true,
          escapeWithReference: true,
          boundariesElement: document.querySelector('.ReactModal__Content'),
        },
      }}
    />
  )
}

DatePicker.Field = ({
  value,
  placeholder,
  minDate,
  onChange,
  onBlur,
  onFocus,
  touched,
  error,
  ...props
}) => {
  return (
    <DatePicker
      value={value}
      placeholderText={placeholder}
      minDate={minDate}
      customInput={<TextInput {...props} kind={touched && error ? 'warning' : undefined} />}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
    />
  )
}

export default DatePicker
